import { apTemplateService } from "../services";

// STATE
const state = {
  item: {},
  items: [],
  loading: false
};

// ACTIONS
const actions = {
  // get the ap-template by his ID
  GET_APT_BY_ID({ commit }, options) {

    // triger mutation -> loading = true
    commit("requestSent");
    return new Promise((resolve, reject) => {
      apTemplateService.getById(options.id).then(
        // fetch success, add collection of  aptemplates to the state
        apt => {

          // triger mutation -> item = apt
          commit("fetchItemSuccess", apt);

          // return resolved promise
          resolve(apt);
        },
        error => {
          commit("requestFail");
          reject(error);
        }
      );
    });
  },

  // create new ap-template
  CREATE_AP_TEMPLATE({ commit }, options) {
    return new Promise((resolve, reject) => {
      apTemplateService.createAPT(options).then(
        apt => {
          commit("fetchItemSuccess", apt);
          resolve(apt);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  // update existing ap-template
  UPDATE_AP_TEMPLATE({ commit }, options) {
    return new Promise((resolve, reject) => {
      apTemplateService.updateAPT(options).then(
        apt => {
          commit("fetchItemSuccess", apt);
          resolve(true);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  // get all ap-templates by language
  GET_AP_TEMPLATES({ commit }, options) {
    commit("requestSent");
    return new Promise((resolve, reject) => {
      apTemplateService.getAll(options).then(
        templates => {
          commit("fetchItemsSuccess", templates);
          resolve(true);
        },
        error => {
          commit("requestFail");
          reject(error);
        }
      );
    });
  },

  // update question pivot table
  // add new question to the template
  INSERT_QUESTION_TO_TEMPLATE({ commit }, options) {
    return new Promise((resolve, reject) => {
      apTemplateService.updateQuestionPivot(options).then(
        apt => {
          commit("fetchItemSuccess", apt);
          resolve(true);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  // remove question from pivot table
  DELETE_QUESTION_FROM_TEMPLATE({ commit }, options) {
    return new Promise((resolve, reject) => {
      apTemplateService.removeQuestionFromPivot(options).then(
        apt => {
          commit("fetchItemSuccess", apt);
          resolve(apt);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  // reset collection to init state []
  RESET_DATA({ commit }) {
    commit("resetData");
  }
};

// MUTATIONS
const mutations = {
  requestSent(state) {
    state.loading = true;
  },
  fetchItemSuccess(state, item) {
    state.loading = false;
    state.item = item;
  },

  fetchItemsSuccess(state, items) {
    state.loading = false;
    state.items = items;
  },

  requestFail(state) {
    state.loading = false;
    state.item = {};
    state.items = [];
  },
  resetData(state) {
    state.items = [];
  }
};

// GETTERS
const getters = {};

// EXPORT
export const apTemplate = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
